import OrgAdminLayout from '../components/OrgAdminLayout';
import TodoList from '../components/TodoList';
import { Card } from '../../design-system';

// Standalone "To-Do" page (sidebar nav). Shows EVERY to-do in the org — both
// standalone/general ones and those raised inside a task — each labelled with
// where it came from. (It used to show only the current user's personal ones,
// which hid all the task-linked work.)
function OrgAdminTodos() {
  return (
    <OrgAdminLayout title="To-Do" subtitle="Every to-do across your firm — general and task-linked">
      <Card padding="md">
        <TodoList scope="all" enableDetailModal />
      </Card>
    </OrgAdminLayout>
  );
}

export default OrgAdminTodos;
